import React, { useRef, useState } from "react";
import styles from "./index.module.css";
import Input from "../components/Input";
import Button from "../components/Button";
import { useData } from "../contexts/DataContext";
import { countrys, educations, genders, yearlists } from "../config/input";
import brain from "../static/images/component_pic/brain.png";
import { startGameApi } from "../api";

function Index(props) {

  const refLoading = useRef(false);
  const [errors, setErrors] = useState({});

  const {
    birthYear,
    gender,
    education,
    country,
    updateCountry,
    updateEducation,
    updateGender,
    updateYear,
    updateId,
  } = useData();

 

  const startGame = async () => {
    if (refLoading.current) return;
    let newErrors = {};

    if (!birthYear) {
      newErrors = { ...newErrors, year: "กรุณาระบุปีเกิด" };
    }

    if (!gender) {
      newErrors = { ...newErrors, gender: "กรุณาระบุเพศ" };
    }

    if (!education) {
      newErrors = { ...newErrors, education: "กรุณาระบุระดับการศึกษา" };
    }

    if (!country) {
      newErrors = { ...newErrors, country: "กรุณาระบุจังหวัด" };
    }
    setErrors(newErrors);


    if (Object.keys(newErrors).length) {
      return;
    }

    refLoading.current = true;

    const data = new FormData();
    data.append("birth_year", birthYear);
    data.append("gender", gender);
    data.append("degree_level", education);
    data.append("province_id", country);

    try {
      const id = await startGameApi(data);
      updateId(id);
      props.navigateNextPage();
    } catch (err) {
      alert("ไม่สามารถเริ่มเล่นเกมได้");
    } finally {
      refLoading.current = false;
    }
  };

  return (
    <div>
      <div className={styles.header}>
        <img className={styles.img} src={brain} alt="brain"></img>
        <h1 className={styles.h1}>เกมทดสอบทักษะสมอง</h1>
        <div className={styles.subheader1}>กรุณาระบุข้อมูลของท่าน</div>
        <div className={styles.subheader2}>ก่อนเริ่มทำการทดสอบ</div>
      </div>
      <form className={styles.form}>
        <Input
          values={yearlists}
          header={"ปีเกิด"}
          state={birthYear}
          Setstate={updateYear}
          placeHolder={"เลือกปีเกิด"}
          error={errors["year"]}
        />
        <Input
          values={genders}
          header={"เพศ"}
          state={gender}
          Setstate={updateGender}
          placeHolder={"เลือกเพศ"}
          error={errors["gender"]}
        />
        <Input
          values={educations}
          header={"ระดับการศึกษา"}
          state={education}
          Setstate={updateEducation}
          placeHolder={"เลือกระดับการศึกษา"}
          error={errors["education"]}
        />
        <Input
          values={countrys}
          header={"จังหวัด"}
          state={country}
          Setstate={updateCountry}
          placeHolder={"เลือกจังหวัด"}
          error={errors["country"]}
        />
      </form>
      <div className={styles.button}>
        <Button onClick={startGame}>ยืนยันข้อมูล</Button>
      </div>
      <div className={styles.air}></div>
    </div>
  );
}

export default Index;

